
import SupportAgentOutlined from '@mui/icons-material/SupportAgentOutlined';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import HelpOutline from '@mui/icons-material/HelpOutline';
import RocketLaunchOutlined from '@mui/icons-material/RocketLaunchOutlined';


// Importera inline-SVG-komponenter
import { ReactComponent as AddUsersIcon } from '../img/add_users-transparent_small.svg';
//import { ReactComponent as DocumentAddIcon } from '../img/document-add-transparent_small.svg';
import { ReactComponent as RocketIcon } from '../img/rocket-transparent_small.svg';
//import { ReactComponent as LoginIcon } from '../img/loggain-skapakonto-transparent_small.svg';
import { ReactComponent as InspirationIcon } from '../img/inspiration_small.svg';
import { ReactComponent as VideohandledningarIcon } from '../img/videohandledningar_small_transparent.svg';
import { ReactComponent as SystemIcon } from '../img/systemkrav-transparent_small.svg';
import { ReactComponent as TopicsIcon } from '../img/topics-transparent_small.svg';

export const helpTopics = [
  [
    {
      title: 'Kom igång med UniQueue',
      description: 'Vi hjälper dig att snabbt komma igång och jobba smart från start.',
      linkText: 'Kom igång »',
      icon: RocketIcon,
      iconType: 'svg',
    },
    {
      title: 'Ämnen',
      description: 'Sök och leta bland olika ämnen och lär dig använda UniQueue smartare.',
      linkText: 'Se filmerna »',
      icon: TopicsIcon,
      iconType: 'svg',
    },
    {
      title: 'Videohandledningar',
      description: 'Lär dig UniQueue med hjälp av korta, pedagogiska filmer – steg för steg.',
      linkText: 'Se filmerna »',
      icon: VideohandledningarIcon,
      iconType: 'svg',
    },
    {
      title: 'Användarfall',
      description: 'Inspireras av hur andra arbetar smartare i sin vardag med UniQueue.',
      linkText: 'Utforska användarfall »',
      icon: InspirationIcon,
      iconType: 'svg',
    },
    {
      title: 'Skapa konto och logga in',
      description: 'Så här skapar du konto och loggar in första gången.',
      linkText: 'Läs mer »',
      icon: AddUsersIcon,
      iconType: 'svg',
    },
    {
      title: 'Välj rätt behörighet',
      description: 'Vilken roll har du? Här förklarar vi skillnaderna.',
      linkText: 'Läs mer »',
      icon: RocketIcon,
      iconType: 'svg',
    },
    {
      title: 'Systemkrav',
      description: 'Vilken utrustning eller webbläsare rekommenderas?',
      linkText: 'Läs mer »',
      icon: SystemIcon,
      iconType: 'svg',
    },
  ],
  [
    {
      title: 'Skapa en beställning',
      description: 'Lär dig beställa material eller tjänster i UniQueue.',
      linkText: 'Läs mer »',
      iconType: 'mui',
      icon: <RocketLaunchOutlined />,
    },
    {
      title: 'Publicera information',
      description: 'Så här publicerar du ett dokument eller en nyhet.',
      linkText: 'Läs mer »',
      iconType: 'mui',
      icon: <RocketLaunchOutlined />,
    },
    {
      title: 'Hantera kontakter',
      description: 'Så hittar och uppdaterar du kontaktpersoner.',
      linkText: 'Läs mer »',
      iconType: 'mui',
      icon: <HelpOutline />,
    },
    {
      title: 'Statistik och rapporter',
      description: 'Skapa översikter över dina aktiviteter.',
      linkText: 'Läs mer »',
      iconType: 'mui',
      icon: <HelpOutline />,
    },
  ],
  [
    {
      title: 'Video: Så fungerar beställningar',
      description: 'Kort demo om hur du beställer steg för steg.',
      linkText: 'Videohandledningar »',
      iconType: 'mui',
      icon: <PlayCircleOutline />,
    },
    {
      title: 'Video: Kom igång',
      description: 'Snabbstartsvideo för nya användare.',
      linkText: 'Videohandledningar »',
      iconType: 'svg',
      icon: RocketIcon,
    },
  ],
  [
    {
      title: 'Kontakta supporten',
      description: 'Behöver du hjälp? Så här kontaktar du oss.',
      linkText: 'Läs mer »',
      iconType: 'mui',
      icon: <SupportAgentOutlined />,
    },
    {
      title: 'Vanliga frågor (FAQ)',
      description: 'Svar på frågor som ofta ställs.',
      linkText: 'Läs mer »',
      iconType: 'mui',
      icon: <HelpOutline />,
    },
  ],
];
